import { useState, useEffect } from "react";
import { IoIosCloseCircle } from "react-icons/io";
import Header from "./Header/Header";
import Sidebar from "./Sidebar/Sidebar";
import { FaChevronLeft } from "react-icons/fa6";
import { Link, useParams, useNavigate,useLocation } from "react-router-dom";
import Footer from "./Footer/Footer";
import success_popup_img from "../assets/success_popup_img.webp";
import sellsecondaryimg  from "../assets/sellsecondaryimg.webp";
import MarketDetailSkeleton from "./MarketDetailSkeleton";

import {
  useWeb3Modal,
  useWeb3ModalAccount,
  useWeb3ModalProvider,
} from "@web3modal/ethers/react";

import { BrowserProvider } from "ethers";

import { toast } from "react-toastify";


// Import your API service
import apiService from "../core/Service/detail";
import { postMethod } from "../core/service/common.api";

const SecondMarketDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
    const location = useLocation();

      // Web3Modal hooks
      const { open } = useWeb3Modal();
      const { isConnected, address, chainId } = useWeb3ModalAccount();
      const { walletProvider } = useWeb3ModalProvider();

      const tokenData = location.state?.data;

  const [propertyDetail, setPropertyDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [buyLoading, setBuyLoading] = useState(false);
  const [tokensToBuy, setTokensToBuy] = useState(1);
  const [relatedAssets, setRelatedAssets] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState("");

  const [stockSymbol, setStockSymbol] = useState("null"); // 👈 store stock symbol

  

  useEffect(() => {
    if (id && tokenData) {
        setLoading(true)
      setPropertyDetail(tokenData);
       setLoading(false)
    }
    
  }, [id,tokenData]);

  if (!propertyDetail) {
    return (
      <>
        <Header />
        <main className="main_flx">
          <Sidebar />
          <div className="right_wrap market_wrap_main market_Detail_main">
            <div className="error-message">Property not found</div>
          </div>
        </main>
      </>
    );
  }

  
    const sellPropertyToken = async () => {
    try {
      if (!walletProvider) {
        throw new Error("Wallet provider not available");
      }
  
      // Create provider & signer (same as buyPropertyToken)
      const provider = new BrowserProvider(walletProvider);
      const signer = await provider.getSigner();
      const userAddress = await signer.getAddress();
  
      let message = "Sell Token";
  
      // Sign message
      const signature = await signer.signMessage(message);
  
      console.log("✅ Message signed");
      console.log("User:", userAddress);
      console.log("Message:", message);
      console.log("Signature:", signature);
  
      return {
        success: true,
        address: userAddress,
        message,
        signature,
      };
    } catch (err) {
      console.error("❌ Message signing failed:", err);
      return {
        success: false,
        message: err.message || "Unknown error",
      };
    }
  };
  
    // Handle form submission
    const handleInvest = async () => {
  
      try {
        setBuyLoading(true);
  
        // Buy tokens
        const result = await sellPropertyToken();
  
        if (result.success) {
          // Record purchase in backend
          await recordSell();
  
          // Show success modal
          document.getElementById("successfullyPopup").classList.add("show");
        } else {
          toast.error(result.message || "Sell failed");
        }
      } catch (error) {
        console.error("Sell failed:", error);
        toast.error(error.message || "Sell failed");
      } finally {
        setBuyLoading(false);
      }
    };
  
    // Record purchase in backend
    const recordSell = async () => {
      try {
        const purchaseData = {
          walletAddress: address
        };
  
        const response = await postMethod({
          apiUrl: apiService.sellTokens,
          payload: purchaseData,
        });
  
        if (response.status === true) {
          toast.success("Sold successfully!");
          navigate("/portfolio");
        } else {
          toast.error("Sell completed but failed to record in database");
        }
      } catch (error) {
        console.error("Backend recording failed:", error);
        toast.error("Sell completed but failed to record in database");
      }
    };


  return (
    <>
      <Header />

      <main className="main_flx">
        <Sidebar />

        {loading ? (
          // <div className="loading-overlay">
          //   <Oval
          //     color="#292B2C"
          //     secondaryColor="#D9D9D9"
          //     strokeWidth={2}
          //     height={75}
          //     width={75}
          //   />
          // </div>
          <MarketDetailSkeleton />
        ) : (
          <>
            <div className="right_wrap market_wrap_main market_Detail_main">
              <div className="market_Detail_wrp">
                <Link to={"/secondarymarket"} className="page_back_common">
                  <FaChevronLeft />
                  <span>Back to Market</span>
                </Link>

                <div className="market_details_card">
                  <div className="mrkt_detl_mai_crd">
                    {/* Left Side - Property Details */}
                    <div className="detl_crd_one mrk_lft_sidecrd">
                      <div className="mrkt_top_title">
                        <div className="img_div">
                          <img
                            src={
                              propertyDetail.cardImg
                            }
                            alt={propertyDetail.cardImg}
                            
                          />
                        </div>
                        <h6>{propertyDetail.cardTitle}</h6>
                        {propertyDetail.status === "active" && (
                          <span className="mrkt_sts">Active</span>
                        )}
                      </div>

                      <div className="mrktcard_main_img">
                        <img
                          src={
                            propertyDetail.cardImg
                          }
                          alt={propertyDetail.cardImg}
                          
                        />
                      </div>

                      <div className="mrkt_main_cd_tlt">
                        <h3>{propertyDetail.cardTitle}</h3>
                        <h5>
                          {propertyDetail.cardSubTitle ||
                            propertyDetail.cardSubTitle}
                        </h5>
                        <p>{propertyDetail.description}</p>
                      </div>

                      <ul className="mrkt_crd_list">
                        <li>
                          <h6>Asset Class</h6>
                          <p>{propertyDetail.assetClass}</p>
                        </li>
                        <li>
                          <h6>Target Returns</h6>
                          <p>{propertyDetail.targetReturns}</p>
                        </li>
                        <li>
                          <h6>Your Holdings</h6>
                          <p>{propertyDetail.fundTerm}</p>
                        </li>
                        <li>
                          <h6>Current Market Value</h6>
                          <p>
                            USD {propertyDetail.minInvestment?.toLocaleString()}
                          </p>
                        </li>
                      </ul>

                      {/* Asset Specific Details */}
                      {/* {assetSpecificDetails.length > 0 && (
                        <div className="prpty_inform_wrp">
                          <h6>Asset Information</h6>
                          <ul>
                            {assetSpecificDetails.map((detail, index) => (
                              <li key={index}>
                                <span>{detail.label}</span>
                                <span>{detail.value}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )} */}

                      <div className="mrk_button_cdone">
                        <button
                          className="Cancel"
                          onClick={() => navigate("/secondarymarket")}
                        >
                          Cancel
                        </button>
                        <button
                          className="mrkt_common_btn invest_now"
                          onClick={() =>
                            document
                              .getElementById("investmentSection")
                              .scrollIntoView({ behavior: "smooth" })
                          }
                        >
                          Sell Now
                        </button>
                      </div>
                    </div>

                    {/* Right Side - Investment Section */}
                    <div className="mrk_rgt_side_wrp">
                      <div
                        className="detl_crd_two mrk_rgt_sidecrd detl_crd_twosecondary"
                        id="investmentSection"
                      >
<div className="sellsecondary_head">

 <img
                            className="sellsecondaryimg "
                            src={sellsecondaryimg}
                          />

                          <div className="selling_urbantok">
                            <h4>Selling your Urban Blocks Tokens <img src={new URL(propertyDetail.logoImg, import.meta.url).href}
                        alt={propertyDetail.cardTitle}
                        className="card_imgsellsecond" /></h4>
                            <p>Owned tokens {' '} <span>100 UB</span></p>
                          </div>
</div>
                       
                       

                        <div className="money_input_wrp money_input_wrpnew">
                          <label>Enter number of tokens to sell</label>
                          <div className="money_input_main">
                            <input
                              placeholder="Enter number of tokens"
                              type="number"
                              value={tokensToBuy}
                              // onChange={(e) => {
                              //   const value = parseInt(e.target.value);
                              //   if (!isNaN(value) && value >= 0) {
                              //     setTokensToBuy(
                              //       Math.min(
                              //         value,
                              //         propertyDetail.availableTokens
                              //       )
                              //     );
                              //   }
                              // }}
                            />
                          </div>
                        
                        </div>
                        <div className="money_input_wrp money_input_wrpnew">
                          <label>Price per Token</label>
                          <div className="money_input_main">
                            <input
                              placeholder="Enter number of tokens"
                              type="number"
                              value={tokensToBuy}
                              onChange={(e) => {
                                const value = parseInt(e.target.value);
                                if (!isNaN(value) && value >= 0) {
                                  setTokensToBuy(
                                    Math.min(
                                      value,
                                      propertyDetail.availableTokens
                                    )
                                  );
                                }
                              }}
                              min="1"
                              max={propertyDetail.availableTokens}
                            />
                          </div>
                          <span>
                            Total Estimated Value{" "}
                            <span className="auto_estimatedsec">$0 (auto-calculated)</span>
                          </span>
                        </div>

 <div className="tokeniz_checkbox_main secondtokeniz_checkbox_main">
                          <div className="common_chkbox_main">
                            <div className="common_chkbox_wrp">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                 
                                />
                              </div>
                              <p>
                                I confirm that the tokens I am listing for sale are owned by me and are free from any existing claims or lock-ins.
                              </p>
                            </div>
                            
                          </div>

                          <div className="common_chkbox_main">
                            <div className="common_chkbox_wrp">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  
                                />
                              </div>
                              <p>
                                I acknowledge that this transaction is irreversible once processed and complies with Terms & Conditions.
                              </p>
                            </div>
                           
                          </div>
                        </div>

                        <button
                          onClick={() => {
                            handleInvest();
                          }}
                          disabled={buyLoading}
                          className="money_send_btn mrkt_common_btn"
                        >
                          {buyLoading ? "Processing..." : "Confirm Sell"}
                        </button>

                        
                      </div>

                      {/* Details Tabs */}
                     
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-5">
                <Footer />
              </div>
            </div>

            <div
              className="modal fade successfull_popup common_popup_main"
              id="successfullyPopup"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <img
                      className="success_popup_img"
                      src={success_popup_img}
                      alt="Success"
                    />
                    <h5 className="modal-title">
                      You have successfully <br /> invested in{" "}
                      {propertyDetail?.fundName}.
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() =>
                        document
                          .getElementById("successfullyPopup")
                          .classList.remove("show")
                      }
                    >
                      <IoIosCloseCircle />
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="successfull_wrp_popup">
                      <div className="successfull_content">
                        <ul>
                          <li>
                            <h4>Amount Invested</h4>
                            <span>-</span>
                            <h6>
                              ${10} (
                              {tokensToBuy} tokens)
                            </h6>
                          </li>
                          <li>
                            <h4>Asset Name</h4>
                            <span>-</span>
                            <h6>{propertyDetail?.fundName}</h6>
                          </li>
                          <li>
                            <h4>Ownership Type</h4>
                            <span>-</span>
                            <h6>Fractional (Tokenized Units)</h6>
                          </li>
                          <li>
                            <h4>Est. Annual Yield</h4>
                            <span>-</span>
                            <h6>{propertyDetail?.targetReturns}</h6>
                          </li>
                          <li>
                            <h4>Transaction Hash</h4>
                            <span>-</span>
                            <h6 className="trnsnumber_id">0x9f3…d81a</h6>
                          </li>
                        </ul>
                      </div>
                      <div className="succfl_btn_wrp">
                        <button
                          className="successfull_fotm_btn"
                          onClick={() => navigate("/portfolio")}
                        >
                          Go to Portfolio
                        </button>
                        <button
                          className="invset_fotm_btn"
                          onClick={() =>
                            document
                              .getElementById("successfullyPopup")
                              .classList.remove("show")
                          }
                        >
                          Invest more
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </main>
    </>
  );
};

export default SecondMarketDetails;
